var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocx(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 30 30",
    height: "30px",
    id: "Layer_1",
    viewBox: "0 0 30 30",
    width: "30px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28.692,7.584l-5.459-6.33L22.154,0H9.257C7.526,0,6.125,1.402,6.125,3.134v3.984h1.942L8.066,3.897   c0.002-0.974,0.785-1.762,1.757-1.762l11.03-0.01V7.35c0.001,1.946,1.574,3.522,3.521,3.522h3.818l-0.188,15.074   c-0.002,0.97-0.788,1.752-1.758,1.759L9.685,27.698c-0.886,0-1.6-0.871-1.604-1.942v-1.274H6.135v1.901   c0,1.914,1.281,3.467,2.854,3.467l17.824-0.006c1.73,0,3.135-1.409,3.135-3.135V9.043L28.692,7.584",
    fill: "#434440"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.213,25.451H0V6.147h20.213V25.451 M1.942,23.509h16.326V8.09H1.942",
    fill: "#2372BA"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "#2372BA",
    points: "17.052,11.922 14.098,20.895 11.646,20.895 9.958,15.694 8.188,20.895 5.744,20.895 2.985,11.922    5.498,11.922 7.105,17.721 9.063,11.922 10.974,11.922 12.796,17.721 14.543,11.922 17.052,11.922  "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocx);
export default __webpack_public_path__ + "static/media/docx.b77de2c09ec44bfbf54f64df3a176030.svg";
export { ForwardRef as ReactComponent };